import SystemFlowHero from '@/components/feature/SystemFlowHero';
import KpiCard from '@/components/base/KpiCard';
import DashboardCharts from './components/DashboardCharts';
import { kpiData } from '@/mocks/dashboardData';

const HomePage: React.FC = () => {
  return (
    <div>
      <div className="mb-4">
        <h1 className="text-xl font-bold text-white" style={{ fontFamily: 'Inter, sans-serif' }}>Genel Dashboard</h1>
        <p className="text-xs mt-0.5" style={{ color: '#6b7280' }}>Bugün — 14 Nisan 2026</p>
      </div>

      <SystemFlowHero />

      {/* KPI Cards */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 mb-5">
        <KpiCard
          label="Günlük Başvuru"
          value={kpiData.dailyApplications}
          change={kpiData.dailyApplicationsChange}
          icon="ri-user-add-line"
          navigateTo="/applications"
          detail={{
            description: 'Bugünkü uzman başvuru özeti',
            trend: 'Son 7 günlük ortalama: 89 başvuru',
            items: [
              { label: 'Bekleyen', value: '34', color: '#f59e0b' },
              { label: 'İncelemede', value: '18', color: '#60a5fa' },
              { label: 'Onaylanan', value: '22', color: '#10b981' },
              { label: 'Reddedilen', value: '13', color: '#ef4444' },
              { label: 'Haftalık Toplam', value: '622' },
              { label: 'Aylık Toplam', value: '2.480' },
            ],
          }}
        />
        <KpiCard
          label="Onay Oranı"
          value={kpiData.approvalRate}
          change={kpiData.approvalRateChange}
          icon="ri-check-double-line"
          suffix="%"
          navigateTo="/applications"
          detail={{
            description: 'Başvuru kabul analizi',
            trend: 'Sektör ortalaması: %31',
            items: [
              { label: 'Bu Ay Onaylanan', value: '868', color: '#10b981' },
              { label: 'Bu Ay Reddedilen', value: '1.612', color: '#ef4444' },
              { label: 'Ortalama İnceleme Süresi', value: '4.2 saat' },
              { label: 'Ort. Red Sebebi', value: 'Eksik Belge', color: '#f59e0b' },
              { label: 'Geçen Ay Oranı', value: '%33' },
            ],
          }}
        />
        <KpiCard
          label="Ort. Uzman Skoru"
          value={kpiData.avgExpertScore}
          change={kpiData.avgExpertScoreChange}
          icon="ri-star-line"
          suffix="/5"
          navigateTo="/scoring"
          detail={{
            description: 'Uzman kalite skor özeti',
            trend: 'Son 30 günde +0.3 artış',
            items: [
              { label: '4.5+ Skor', value: '76 uzman', color: '#10b981' },
              { label: '4.0–4.5 Skor', value: '134 uzman', color: '#ff8c42' },
              { label: '3.5–4.0 Skor', value: '87 uzman', color: '#f59e0b' },
              { label: '3.5 Altı', value: '85 uzman', color: '#ef4444' },
              { label: 'En Yüksek Skor', value: '4.9 / Kemal Ç.', color: '#ffd700' },
            ],
          }}
        />
        <KpiCard
          label="Aktif Randevu"
          value={kpiData.activeAppointments}
          change={kpiData.activeAppointmentsChange}
          icon="ri-calendar-check-line"
          navigateTo="/matching"
          detail={{
            description: 'Anlık randevu durumu',
            trend: 'Bugün 214 randevu aktif',
            items: [
              { label: 'Devam Eden', value: '86', color: '#10b981' },
              { label: 'Başlamayı Bekleyen', value: '128', color: '#f59e0b' },
              { label: 'Tamamlanan (bugün)', value: '147', color: '#60a5fa' },
              { label: 'İptal Edilen (bugün)', value: '21', color: '#ef4444' },
              { label: 'Ort. Randevu Süresi', value: '48 dk' },
            ],
          }}
        />
        <KpiCard
          label="Günlük Gelir"
          value={kpiData.dailyRevenue.toLocaleString('tr-TR')}
          change={kpiData.dailyRevenueChange}
          icon="ri-money-dollar-circle-line"
          suffix=" ₺"
          navigateTo="/revenue"
          detail={{
            description: 'Bugünkü gelir kırılımı',
            trend: 'Haftalık hedef: 350.000 ₺',
            items: [
              { label: 'Uzman Kazancı (%70)', value: '34.125 ₺', color: '#10b981' },
              { label: 'Platform Komisyonu (%30)', value: '14.625 ₺', color: '#ff6b47' },
              { label: 'Tamamlanan İş', value: '65 adet' },
              { label: 'Ort. İşlem Değeri', value: '750 ₺' },
              { label: 'Dünkü Gelir', value: '40.010 ₺' },
            ],
          }}
        />
        <KpiCard
          label="Lead → Randevu"
          value={kpiData.leadToAppointment}
          change={kpiData.leadToAppointmentChange}
          icon="ri-exchange-line"
          suffix="%"
          navigateTo="/leads"
          detail={{
            description: 'Lead dönüşüm analizi',
            trend: 'Geçen hafta: %19.8',
            items: [
              { label: 'Günlük Lead', value: '298', color: '#e5e7eb' },
              { label: 'Randevuya Dönüşen', value: '66', color: '#10b981' },
              { label: 'Eşleşme Başarısı', value: '%78', color: '#ff8c42' },
              { label: 'Ortalama Dönüşüm Süresi', value: '1.8 saat' },
              { label: 'Kayıp Lead Sebebi', value: 'Müsait Uzman Yok', color: '#ef4444' },
            ],
          }}
        />
        <KpiCard
          label="Müşteri Puanı"
          value={kpiData.avgCustomerRating}
          change={kpiData.avgCustomerRatingChange}
          icon="ri-emotion-happy-line"
          suffix="/5"
          navigateTo="/experts"
          detail={{
            description: 'Müşteri memnuniyet özeti',
            trend: 'Son 90 günlük ortalama: 4.5',
            items: [
              { label: '5 Yıldız', value: '%58', color: '#ffd700' },
              { label: '4 Yıldız', value: '%27', color: '#ff8c42' },
              { label: '3 Yıldız', value: '%9', color: '#f59e0b' },
              { label: '1-2 Yıldız', value: '%6', color: '#ef4444' },
              { label: 'Toplam Değerlendirme', value: '4.820 adet' },
            ],
          }}
        />
      </div>

      <DashboardCharts />
    </div>
  );
};

export default HomePage;
